import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const CroatiaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'HR',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Croatia',
  SHORT_NAME: 'HR',

  DISPLAY_NAME: 'Croatia (English)',
  DISPLAY_COUNTRY: 'Croatia (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 44.4202877,
    INITIAL_LONGITUDE: 13.7665855,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Bjelovar-Bilogora',
    '2': 'Brod-Posavina',
    '3': 'City of Zagreb',
    '4': 'Dubrovnik-Neretva',
    '5': 'Istria',
    '6': 'Karlovac',
    '7': 'Koprivnica-Križevci',
    '8': 'Krapina-Zagorje',
    '9': 'Lika-Senj',
    '10': 'Međimurje',
    '11': 'Osijek-Baranja',
    '12': 'Požega-Slavonia',
    '13': 'Primorje-Gorski Kotar',
    '14': 'Šibenik-Knin',
    '15': 'Sisak-Moslavina',
    '16': 'Split-Dalmatia',
    '17': 'Varaždin',
    '18': 'Virovitica-Podravina',
    '19': 'Vukovar-Syrmia',
    '20': 'Zadar',
    '21': 'Zagreb County',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-hr/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-hr/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default CroatiaLocale
